import styled from "styled-components"
import theme from "../../themes"

const TextArea = styled.textarea`
  font-size: ${theme.main.sizes.typography.mobile.p};
  background: none;
  border: none;
  border-bottom: 2px solid black;
  -webkit-border-radius: 0;
  border-radius: 0;
  padding: 16px 0;
  outline: none;
  width: 100%;
  margin-bottom: 32px;
`

export default TextArea
